import axios from 'axios';
import { refreshTokenAPI } from './providers/authApi';
import { authStore } from './providers/authStore';

function httpClient() {

  const instance = axios.create({
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${localStorage.getItem('access_token') || ''}`,
    },
  });

  instance.interceptors.response.use(
    (response) => response,
    async (error) => {
      if (error.response.status === 401) {
        try {
          const token = await refreshTokenAPI(
            localStorage.getItem('refresh_token') || ''
          );
          const originalRequest = error.config;
          originalRequest.headers['Authorization'] = `Bearer ${token.accessToken || ''}`;
          authStore.setTokens(
            token.accessToken || '',
            token.refreshToken || ''
          );
          return instance(originalRequest);
        } catch (refreshError) {
          console.error('Refresh token failed:', refreshError);
          // window.location.href = '/login';
        }
      }
      return Promise.reject(error);
    }
  );

  return instance;
}

export { httpClient };
